import type { components } from "../../../api/generated";
import type {
  DicStayAreaGeoResolveRequest,
  DicStayAreaListParams,
  DicStayAreaMutation,
} from "../types";

export type DicStayAreaItemRaw = components["schemas"]["DicStayAreaItem"];
export type DicStayAreaListPageRaw = components["schemas"]["DicStayAreaListPage"];
export type GeoAreaResolveResultRaw = components["schemas"]["GeoAreaResolveResult"];

/** 映射住宿点分页查询参数。 */
export function mapDicStayAreaListQueryParams(params: DicStayAreaListParams) {
  return {
    page: params.page,
    page_size: params.pageSize,
    keyword: normalizeOptionalText(params.keyword),
    province: normalizeOptionalText(params.province),
    city: normalizeOptionalText(params.city),
    is_disabled: params.isDisabled,
    sort_field: params.sortField,
    sort_direction: params.sortDirection,
  };
}

/** 映射住宿点新增与编辑载荷。 */
export function mapDicStayAreaMutationPayload(payload: DicStayAreaMutation) {
  return {
    stay_area_name: payload.stayAreaName.trim(),
    spell_code: payload.spellCode.trim(),
    area_level: payload.areaLevel.trim(),
    province: payload.province.trim(),
    city: payload.city.trim(),
    district: payload.district.trim(),
    township: payload.township.trim(),
    navigation_address: payload.navigationAddress.trim(),
    lng: payload.lng,
    lat: payload.lat,
    is_disabled: payload.isDisabled,
    is_ai_created: payload.isAiCreated,
    remark: payload.remark.trim(),
  };
}

/** 映射 GEO 识别载荷。 */
export function mapDicStayAreaGeoResolvePayload(payload: DicStayAreaGeoResolveRequest) {
  return {
    province: payload.province.trim(),
    area_name: payload.areaName.trim(),
    scenario: payload.scenario ?? "stay_area",
    context_name: normalizeOptionalText(payload.contextName),
  };
}

/** 归一化可选文本值。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
